import gql from 'graphql-tag';

export const STOCK_TRANSFERS_UPDATED_SUBSCRIPTION = gql`
    subscription STOCK_TRANSFERS_UPDATED($stockTransferId: ID) {
        stockTransferUpdated(stockTransferId: $stockTransferId) {
            _id
            createdAt
            deliveryId
            destinationColumnId
            destinationColumn {
                fullname
            }
            numberOfRefs
            originColumnId
            originColumn {
                fullname
            }
            products {
                productId
                fullname
                originStockAvailable
                destinationStockAvailable
                quantity
            }
            quantityOfProducts
            state
            stateHistory {
                state
                createdAt
                createdBy
            }
            transferDate
            updatedAt
        }
    }
`;
